module.exports = __webpack_public_path__ + "img/troyes.6110aaaf.png";